export default __webpack_public_path__ + "static/media/bio_writer.99f65e36.svg";